// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmpermspg-inline-1 {
  padding: 0;
  overflow-x: auto;
}

.pmpermspg-inline-2 {
  font-weight: 600;
}

.pmpermspg-inline-3 {
  font-size: 11px;
}

.pmpermspg-inline-4 {
  font-size: 11px;
}

.pmpermspg-inline-5 {
  font-size: 11px;
}

.pmpermspg-inline-6 {
  font-size: 11px;
}

.pmpermspg-inline-7 {
  font-size: 11px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pmpermspg-inline-8 {
  display: flex;
  gap: 4px;
}

.pmpermspg-inline-9 {
  font-size: 10px;
  padding: 3px 8px;
}

.pmpermspg-inline-10 {
  font-size: 10px;
  padding: 3px 8px;
}

.pmpermspg-dyn-1 {
  text-align: center;
  padding: 30px;
  color: var(--pmpermspg-1-color);
}

.pmpermspg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--pmpermspg-2-color);
}

.pmpermspg-dyn-3 {
  font-size: 10px;
  color: var(--pmpermspg-3-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMPermsPg.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".pmpermspg-inline-1 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmpermspg-inline-2 {\n  font-weight: 600;\n}\n\n.pmpermspg-inline-3 {\n  font-size: 11px;\n}\n\n.pmpermspg-inline-4 {\n  font-size: 11px;\n}\n\n.pmpermspg-inline-5 {\n  font-size: 11px;\n}\n\n.pmpermspg-inline-6 {\n  font-size: 11px;\n}\n\n.pmpermspg-inline-7 {\n  font-size: 11px;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pmpermspg-inline-8 {\n  display: flex;\n  gap: 4px;\n}\n\n.pmpermspg-inline-9 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.pmpermspg-inline-10 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.pmpermspg-dyn-1 {\n  text-align: center;\n  padding: 30px;\n  color: var(--pmpermspg-1-color);\n}\n\n.pmpermspg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--pmpermspg-2-color);\n}\n\n.pmpermspg-dyn-3 {\n  font-size: 10px;\n  color: var(--pmpermspg-3-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
